module.exports = __webpack_public_path__ + "static/media/helicopter.fd7f940e.svg";